import { ComponentProps } from 'react';
import { nudosTextcolor } from '../../../../styles/styles.constants';

const BordCommentIcon = (props: ComponentProps<'svg'>) => {
  const { stroke, ...svgRest } = props;
  const strokeColor = stroke ?? nudosTextcolor;

  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgRest}>
      <rect x="4" y="5.3335" width="24" height="18.8157" rx="4" fill="white" />
      <path
        d="M10.6667 12.0002H21.3333M10.6667 17.3335H18.6667M18.6667 24.0002H17.3333L10.6667 28.0002V24.0002H8C6.93913 24.0002 5.92172 23.5787 5.17157 22.8286C4.42143 22.0784 4 21.061 4 20.0002V9.3335C4 8.27263 4.42143 7.25521 5.17157 6.50507C5.92172 5.75492 6.93913 5.3335 8 5.3335H24C25.0609 5.3335 26.0783 5.75492 26.8284 6.50507C27.5786 7.25521 28 8.27263 28 9.3335V15.3335M25.3333 29.3335V29.3468M25.3333 25.3335C25.9311 25.3316 26.5109 25.1292 26.98 24.7588C27.4491 24.3883 27.7803 23.8712 27.9207 23.2902C28.0612 22.7092 28.0026 22.0979 27.7544 21.5541C27.5063 21.0103 27.0829 20.5655 26.552 20.2908C26.0216 20.0191 25.4148 19.9349 24.8304 20.0518C24.246 20.1687 23.7184 20.4799 23.3333 20.9348"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ strokeWidth: '1px', vectorEffect: 'non-scaling-stroke' }}
      />
    </svg>
  );
};

export default BordCommentIcon;
